import { render } from "./TeacherProfile.vue?vue&type=template&id=42cd1fd3&scoped=true"
import script from "./TeacherProfile.vue?vue&type=script&lang=js"
export * from "./TeacherProfile.vue?vue&type=script&lang=js"

import "./TeacherProfile.vue?vue&type=style&index=0&id=42cd1fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cd1fd3"]])

export default __exports__